"use strict";
exports.__esModule = true;
exports.isPlatformERC20TokenCurrency = exports.isPlatformTokenCurrency = exports.isPlatformCryptoCurrency = exports.isPlatformSupportedCurrency = void 0;
var currencies_1 = require("../currencies");
var types_1 = require("./types");
function isPlatformSupportedCurrency(currency) {
    return (0, currencies_1.isCryptoCurrency)(currency) || (0, currencies_1.isTokenCurrency)(currency);
}
exports.isPlatformSupportedCurrency = isPlatformSupportedCurrency;
function isPlatformCryptoCurrency(currency) {
    return currency.type === types_1.PlatformCurrencyType.CryptoCurrency;
}
exports.isPlatformCryptoCurrency = isPlatformCryptoCurrency;
function isPlatformTokenCurrency(currency) {
    return currency.type === types_1.PlatformCurrencyType.TokenCurrency;
}
exports.isPlatformTokenCurrency = isPlatformTokenCurrency;
function isPlatformERC20TokenCurrency(currency) {
    return currency.standard === "ERC20";
}
exports.isPlatformERC20TokenCurrency = isPlatformERC20TokenCurrency;
//# sourceMappingURL=helpers.js.map